import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f6e3544"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "no-clusters"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "flex-col line-height-normal text-center" }
const _hoisted_4 = { class: "gordita-500-13-m text-Text/text_high" }
const _hoisted_5 = { class: "font-gordita-regular text-Text/text_medium text-[12px] pt-[8px]" }
const _hoisted_6 = ["data-testid"]
const _hoisted_7 = { class: "pt-[8px] px-[8px] bg-System/app_white" }
const _hoisted_8 = { class: "flex items-center justify-center" }
const _hoisted_9 = { class: "overflow-auto max-h-[226px] incredi-scroll-bar-narrow" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "w-full p-2 buildcache-cluster-modal-btn" }

import elementsIds from '@/const/elementIds.json';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { computed, ref } from 'vue';
import { IncrediList, IncrediField, IncrediItem, IncrediNote, IncrediTooltip, IncrediButton } from 'incredi-ui';
import { SelectedAgent } from '@/components/agents-table/AgentActionMenu.types';
import { useClustersQuery, ClustersQuery } from '@/graphql/codegen/generated/graphql';
import { useI18n } from 'vue-i18n';
import NO_CLUSTERS_IMG from '@/assets/images/build-cache-clusters/no_cluster.svg';
import IbOkCancelDialog from '@/components/common/dialogs/OkCancelDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'agents-buildCache-clusters',
  props: {
    agents: null
  },
  emits: ["change", "openDialog"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'change', value: { clusterId: number }): void;
  (e: 'openDialog', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  agents: SelectedAgent[];
}





const { t } = useI18n();
const input = ref('');
const isSearchFocused = ref(false);
const hasInitiator = props.agents.some(agent => agent.metadata?.isInitiator || agent.metadata?.isCIInitiator);
const GQL_useClusters = useClustersQuery(undefined, { fetchPolicy: 'network-only' });
const showTooltip = ref<Array<boolean>>([]);
const clusters = computed(() => {
  const emptyState = !GQL_useClusters.result.value?.clusters?.length;
  const selectedClusterName = GQL_useClusters.result.value?.clusters?.find(cluster => props.agents.every(agent => cluster?.nodes?.find(node => node?.agentId === agent.id)))?.name;
  const areAgentsPartOfAnyCluster = !!GQL_useClusters.result.value?.clusters?.find(cluster => props.agents.find(agent => cluster?.nodes?.find(node => node?.agentId === agent.id)));

  const filteredClusters =
    ([{ name: 'None', id: -1 }, ...(GQL_useClusters.result.value?.clusters || [])]
      .filter(cluster => {
        if (cluster) {
          const filterInput = input?.value?.toLowerCase() || '';
          return cluster.name.toLowerCase().includes(filterInput);
        }
        return false;
      })
      .sort((clusterA, clusterB) => {
        if (clusterA?.id === -1 || clusterB?.id === -1) {
          return clusterA?.id === -1 ? -1 : 1;
        }
        if (clusterA?.name === selectedClusterName || clusterB?.name === selectedClusterName) {
          return clusterA?.name === selectedClusterName ? -1 : 1;
        }
        return clusterA?.name.localeCompare(clusterB?.name || '', 'en', { sensitivity: 'base' }) || 0;
      }) as ClustersQuery['clusters']) || [];
  return { filteredClusters, selectedClusterName, emptyState, areAgentsPartOfAnyCluster };
});

const clusterNamesRefs = ref<any>([]);
const setSelectedCluster = ref<{
  id: number;
  name: string;
}>();
const showBuildCacheClusterDialog = ref(false);

const isTruncated = (index: number) => {
  const el = (clusterNamesRefs.value[index] as any)?.$el as any;
  return el?.scrollWidth > el?.offsetWidth;
};

const willClusterBeEmpty = (selectedCluster: { id: number; name: string }): boolean => {
  let isEmpty = false;
  if (selectedCluster?.id === -1) {
    const clustersSizeMap = new Map();
    if (GQL_useClusters.result.value?.clusters?.length) {
      GQL_useClusters.result.value.clusters.forEach(cluster => {
        const clusterCount = { clusterSize: cluster?.nodes?.length || 0 };
        cluster?.nodes?.forEach(node => {
          if (node?.agentId) {
            clustersSizeMap.set(node.agentId, clusterCount);
          }
        });
      });
      props.agents.forEach(agent => {
        if (agent.id) {
          const clusterCount = clustersSizeMap.get(agent.id);
          if (clusterCount) {
            clusterCount.clusterSize -= 1;
            if (clusterCount.clusterSize === 0) {
              isEmpty = true;
            }
          }
        }
      });
    }
  }

  return isEmpty;
};
const onClusterSelect = (cluster: { id: number; name: string }) => {
  setSelectedCluster.value = cluster;
  showBuildCacheClusterDialog.value = cluster?.id === -1 ? willClusterBeEmpty(cluster) : true;
  if (showBuildCacheClusterDialog.value === false) {
    emit('change', { clusterId: cluster?.id || -1 });
  }
};

return (_ctx: any,_cache: any) => {
  const _directive_incredi_focus_trap = _resolveDirective("incredi-focus-trap")!

  return _withDirectives((_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      (_unref(clusters).emptyState)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", { src: _unref(NO_CLUSTERS_IMG) }, null, 8, _hoisted_2),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('agentsTable.actionsMenu.buildCacheClusters.noClusters')), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('agentsTable.actionsMenu.buildCacheClusters.noClustersSubTitle')), 1)
            ]),
            _createVNode(_unref(IncrediButton), {
              design: "primary-green",
              size: "tiny",
              class: "flex items-center justify-center",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('openDialog', true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('agentsTable.actionsMenu.buildCacheClusters.buttonTitle')), 1)
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "max-h-[312px] relative max-w-[260px]",
            "data-testid": _unref(elementsIds).agents.contextMenu.buildCacheClusters.dialog
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(IncrediField), {
                modelValue: input.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((input).value = $event)),
                name: "build-cache-clusters",
                label: "Search",
                size: "tiny",
                clearable: "",
                "data-testid": _unref(elementsIds).agents.contextMenu.buildCacheClusters.input,
                onFocusWithin: _cache[2] || (_cache[2] = ($event: any) => (isSearchFocused.value = true)),
                onBlurWithin: _cache[3] || (_cache[3] = ($event: any) => (isSearchFocused.value = false))
              }, {
                prepend: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["uil uil-search text-[24px] mr-2", [isSearchFocused.value ? 'text-System/app_primary' : 'text-System/app_grey_76']])
                    }, null, 2)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "data-testid"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_unref(hasInitiator))
                ? (_openBlock(), _createBlock(_unref(IncrediNote), {
                    key: 0,
                    type: "Warning",
                    class: "pl-[8px] pt-[8px] pr-[8px] !shadow-none"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('agentsTable.actionsMenu.buildCacheClusters.initiatorWarning')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(IncrediList), { class: "!shadow-none" }, {
                default: _withCtx(() => [
                  (!_unref(clusters)?.filteredClusters?.length)
                    ? (_openBlock(), _createBlock(_unref(IncrediItem), {
                        key: 0,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('agentsTable.actionsMenu.buildCacheClusters.noMatches')), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(clusters).filteredClusters, (cluster, index) => {
                          return (_openBlock(), _createBlock(_unref(IncrediTooltip), {
                            key: index,
                            modelValue: showTooltip.value[index],
                            "onUpdate:modelValue": ($event: any) => ((showTooltip.value[index]) = $event),
                            style: {"height":"32px"},
                            hover: "",
                            delay: 200,
                            direction: "middle-right",
                            "offset-x": 20,
                            disabled: !isTruncated(index)
                          }, {
                            content: _withCtx(() => [
                              _createTextVNode(_toDisplayString(cluster?.name), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_unref(IncrediItem), {
                                ref_for: true,
                                ref: el => (clusterNamesRefs.value[index] = el) as any,
                                class: _normalizeClass(["overflow-hidden text-ellipsis", { 'border-b': cluster?.name === 'None' && _unref(clusters)?.filteredClusters?.length > 1 }]),
                                selected: cluster?.name === _unref(clusters)?.selectedClusterName || (!_unref(clusters)?.selectedClusterName && cluster?.name === 'None' && !_unref(clusters)?.areAgentsPartOfAnyCluster),
                                onClick: ($event: any) => (cluster ? onClusterSelect(cluster) : () => {})
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(cluster?.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["class", "selected", "onClick"])
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]))
                        }), 128))
                      ]))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(IncrediButton), {
                design: "primary-green",
                size: "tiny",
                class: "w-full flex items-center justify-center",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('openDialog', true)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('agentsTable.actionsMenu.buildCacheClusters.buttonTitle')), 1)
                ]),
                _: 1
              })
            ])
          ], 8, _hoisted_6)),
      _createVNode(IbOkCancelDialog, {
        value: showBuildCacheClusterDialog.value,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((showBuildCacheClusterDialog).value = $event)),
        class: "w-[432px]",
        "dialog-title": 
        setSelectedCluster.value?.id !== -1
          ? _unref(t)('agentsTable.actionsMenu.buildCacheClusters.addAgentsToClusterDialogTitle')
          : _unref(t)('agentsTable.actionsMenu.buildCacheClusters.removeAgentsFromClusterDialogTitle')
      ,
        body: 
        setSelectedCluster.value?.id !== -1
          ? _unref(t)('agentsTable.actionsMenu.buildCacheClusters.addAgentsToClusterDialogSubtitle')
          : _unref(t)('agentsTable.actionsMenu.buildCacheClusters.removeAgentsFromClusterDialogSubtitle')
      ,
        "ok-label": setSelectedCluster.value?.id !== -1 ? _unref(t)('agentsTable.actionsMenu.buildCacheClusters.addButton') : _unref(t)('agentsTable.actionsMenu.buildCacheClusters.removeButton'),
        onOk: _cache[6] || (_cache[6] = ($event: any) => (emit('change', { clusterId: setSelectedCluster.value?.id || -1 }))),
        onCancel: _cache[7] || (_cache[7] = ($event: any) => (showBuildCacheClusterDialog.value = false)),
        onHide: _cache[8] || (_cache[8] = ($event: any) => (showBuildCacheClusterDialog.value = false))
      }, null, 8, ["value", "dialog-title", "body", "ok-label"])
    ]),
    _: 1
  })), [
    [_directive_incredi_focus_trap, 'agent-add-buildcache-cluster']
  ])
}
}

})